export interface ServiceModes {
    id: number;
    name: string;
    nameSpanish: string;
}

export enum ServiceRequestStatus {
    created = 0,
    active = 1,
    completed = 2,
    canceled = 3,
    expired = 4,
    completedWithIssues = 5,
    pendingCancellation = 6,
    pendingCompleted = 7
}